import React from "react";
import "./ticketDetail.style";
import { Grid } from '@mui/material';
import parse from 'html-react-parser';
import { NOT_APPLICABLE, REQUEST_STATE, YES, AWAITING_APPROVAL } from '../../../constants/originalState';

export interface INewVirtualDeviceProps {
  infoTicket: any,
  locale: any
};

const NewVirtualDevice = (props: INewVirtualDeviceProps) => {
  const { infoTicket, locale } = props;
  const { variables, approvers } = infoTicket;
  const { json_storage } = variables;
  const conditionDelegatedApprovalRequests = json_storage?.delegated === YES && variables?.stage?.value === AWAITING_APPROVAL && infoTicket?.state === REQUEST_STATE.OPEN;
  return (
    <>
      <Grid container>
        <Grid item xs={6} className="pr-20">
          <p className="ttl-col-desc">{locale?.requestorName}</p>
          <p className="value-info" id="lbl-newvirtualdevice-requestor_name">{json_storage?.requestor_name ? json_storage?.requestor_name: NOT_APPLICABLE}</p>
        </Grid>
        <Grid item xs={6}>
          <p className="ttl-col-desc">{locale?.requestorEmail}</p>
          <p className="value-info" id="lbl-newvirtualdevice-requestor_email">{json_storage?.requestor_email ? json_storage?.requestor_email: NOT_APPLICABLE}</p>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={6} className="pr-20">
          <p className="ttl-col-desc">{locale?.recipientName}</p>
          <p className="value-info" id="lbl-newvirtualdevice-recipient_name">{json_storage?.recipient_name ? json_storage?.recipient_name: NOT_APPLICABLE}</p>
        </Grid>
        <Grid item xs={6}>
          <p className="ttl-col-desc">{locale?.recipientEmail}</p>
          <p className="value-info" id="lbl-newvirtualdevice-recipient_email">{json_storage?.user_email ? json_storage?.user_email: NOT_APPLICABLE}</p>
        </Grid>
      </Grid>

      {!json_storage?.approver_email && !!json_storage?.comments && (
        <Grid container>
          <Grid item xs={12} className="pr-20">
            <p className="ttl-col-desc">{locale?.comments}</p>
            <p className="value-info" id="lbl-newvirtualdevice-comments">{json_storage?.comments ? json_storage?.comments : NOT_APPLICABLE}</p>
          </Grid>
        </Grid>
      )}
      
      <Grid container>
        {!!json_storage?.employee_type && (
          <Grid item xs={6} className="pr-20">
          <p className="ttl-col-desc">{locale?.workerType}</p>
          <p className="value-info" id="lbl-newvirtualdevice-employee_type">{json_storage?.employee_type ? json_storage?.employee_type : NOT_APPLICABLE}</p>
        </Grid>
        )}
        {!!json_storage?.approver_email && (
          <Grid item xs={6} className="pr-20">
            <p className="ttl-col-desc">{locale?.costCenter}</p>
            <p className="value-info" id="lbl-newvirtualdevice-cost_center">{!!json_storage?.cost_center ? json_storage?.cost_center : NOT_APPLICABLE }</p>
          </Grid>
        )}
      </Grid>
      {!!json_storage?.approver_email && (
        <>
          <Grid container>
          <Grid item xs={6} className="pr-20">
            <p className="ttl-col-desc">{conditionDelegatedApprovalRequests ? locale?.managerInfomation : locale?.approverInfo}</p>
            <p className="value-info" id="lbl-newvirtualdevice-approver_email">{!!json_storage?.approver_email ? json_storage?.approver_email : NOT_APPLICABLE}</p>
          </Grid>
          {conditionDelegatedApprovalRequests &&
          <Grid item xs={12} className="pr-20">
            <p className="ttl-col-desc">{locale?.delegatedApproverInfo}</p>
            <p className="value-info" id="lbl-newvirtualdevice-delegated_to_email">{!!json_storage?.delegated_to_email ? json_storage?.delegated_to_email : NOT_APPLICABLE}</p>
          </Grid>}
        </Grid>
        {approvers?.map((items: any) => items.state === REQUEST_STATE.REJECTED ?
          <Grid container>
            <Grid item xs={6}>
              <p className="ttl-col-desc">{locale?.business_justification_comments}</p>
              <p className="value-info" id="lbl-newvirtualdevice-business_justification_comments">{parse(json_storage?.business_justification || '')}</p>
            </Grid>
            <Grid item xs={6} className="pr-20">
              <p className="ttl-col-desc">{locale?.rejectComment}</p>
              <p className="value-info" id="lbl-newvirtualdevice-reject_comment">{ items?.comments?.[0]?.comment }</p>
            </Grid>
          </Grid>
          :
          <Grid container>
            <Grid item xs={6}>
              <p className="ttl-col-desc">{locale?.business_justification_comments}</p>
              <p className="value-info" id="lbl-newvirtualdevice-business_justification_comments">{parse(json_storage?.business_justification || '')}</p>
            </Grid>
          </Grid>
        )}
        </>
      )} 
      {json_storage?.app_name && 
        <Grid container>
          <Grid item xs={12}>
            <p className="ttl-col-desc">{locale?.requestedItem}</p>
            <p className="value-info" id="lbl-newvirtualdevice-app_name">{json_storage?.app_name || NOT_APPLICABLE}</p>
          </Grid>
        </Grid>
      }
    </>
  );
};

export default NewVirtualDevice;